import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, Optional } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import {
  BaseHTTPService,
  HandleErrorOptions
} from '@sondermind/http';
import {
  IHttpErrorHandler,
  HTTP_ERROR_HANDLER
} from '@sondermind/utilities/models-http';

import { PatientRelationship } from '../models/patient-relationship';

@Injectable({
  providedIn: 'root'
})
export class PatientRelationshipDataService extends BaseHTTPService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient,
    @Optional()
    @Inject(HTTP_ERROR_HANDLER)
    httpErr: IHttpErrorHandler[]
  ) {
    super(httpErr);
  }

  private store = new BehaviorSubject<PatientRelationship[]>([]);
  store$ = this.store.asObservable();

  refresh(): Observable<PatientRelationship[]> {
    this.fetch().subscribe((as) => this.store.next(as));
    return this.store$;
  }

  fetch(opts: Partial<HandleErrorOptions> = {}): Observable<PatientRelationship[]> {
    const url = `${this.configurationService.env.apiBase}/v2/patient_relationships`;
    return this.http
      .get<{ patientRelationships: PatientRelationship[]; }>(url)
      .pipe(
        map((p) => p.patientRelationships),

        catchError(this.handleError.bind(this, opts))
      );
  }
}
